var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav",on:{"click":_vm.onClickLeft}},[_c('van-icon',{attrs:{"name":"arrow-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }